const iconsDictionary: { [key: string]: string } = {
  mountain: `mountains`,
  interesting_flora: `flora`,
  special_wildlife: `wildlife`,
  unique_scenery: `unique`,
  roundtrip_culture: `culture`,
  roundtrip_nature: `natur`,
  roundtrip_trips: `trips`,
};

export const mapAttributeNameToIcon = (featureCode: string): string => {
  return iconsDictionary[featureCode] || ('not-found' as const);
};
